import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './OnTheWaySlider.scss';
import leftArrow from '../../../../assets/smartxonnect/left.webp';
import rightArrow from '../../../../assets/smartxonnect/right.webp';
import whiteLeftArrow from '../../../../assets/smartxonnect/left.webp';

const pushDataLayerEvent = (ctaText, brandName, variantName) => {
  dataLayer.push({
    event: 'on_the_way_banner_navigation',
    cta_text: ctaText,
    BrandName: brandName,
    VariantName: variantName,
  });
};

const PrevArrow = ({ className, onClick, isDisabled, setInteraction }) => {
  const handleClick = () => {
    if (!isDisabled) {
      setInteraction('arrow');
      pushDataLayerEvent('Previous', 'TVS iQube', 'SmartXonnect');
      onClick();
    }
  };

  return (
    <div className={`${className} custom-prev-arrow`} onClick={handleClick}>
      <img src={isDisabled ? whiteLeftArrow : leftArrow} alt="Previous" loading="lazy" />
    </div>
  );
};

const NextArrow = ({ className, onClick, isDisabled, setInteraction }) => {
  const handleClick = () => {
    if (!isDisabled) {
      setInteraction('arrow');
      pushDataLayerEvent('Next', 'TVS iQube', 'SmartXonnect');
      onClick();
    }
  };

  return (
    <div className={`${className} custom-next-arrow`} onClick={handleClick}>
      <img
        src={isDisabled ? whiteLeftArrow : rightArrow}
        loading="lazy"
        alt="Next"
        className={isDisabled ? 'disabled' : 'rotate-180'}
      />
    </div>
  );
};

const OnTheWaySlider = (props) => {
  const [expandedItem, setExpandedItem] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const [activeSet, setActiveSet] = useState(0);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const [lastInteraction, setLastInteraction] = useState(null);
  const accordionRef = useRef(null);

  const hasMounted = useRef(false);

  useEffect(() => {
    if (hasMounted.current) {
      // Only run this logic after the initial mount
      if (expandedItem !== null && accordionRef.current) {
        const accordionItem = document.getElementById(`accordion-item-${expandedItem}`);
        if (accordionItem) {
          const rect = accordionItem.getBoundingClientRect();
          const scrollOffset = window.pageYOffset || document.documentElement.scrollTop;
          const targetPosition = rect.top + scrollOffset - 100;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      }
    } else {
      hasMounted.current = true;
    }
  }, [expandedItem]);

  const handleAfterChange = (current) => {
    const newSet = Math.floor(current / 3);
    setActiveSet(newSet);
    setIsAtEnd(current + 3 >= props?.fields?.SliderCards?.length);
  };

  const handleDotsClick = (index) => {
    const dotNumber = `dot ${index + 1}`;
    dataLayer.push({
      event: 'on_the_way_banner_navigation',
      cta_text: dotNumber,
      BrandName: 'TVS iQube',
      VariantName: 'SmartXonnect',
    });
  };

  const handleAccordionClick = (index, cta_text) => {
    dataLayer.push({
      event: 'on_the_way_cta_click',
      cta_text: cta_text,
      BrandName: 'TVS iQube',
      VariantName: 'SmartXonnect',
    });
    setExpandedItem((prevState) => (prevState === index ? null : index));
  };

  const handleShowMore = () => {
    setShowMore(true);
  };

  const handleShowLess = () => {
    setShowMore(false);
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    swipe: true,
    prevArrow: <PrevArrow isDisabled={activeSet === 0} setInteraction={setLastInteraction} />,
    nextArrow: <NextArrow isDisabled={isAtEnd} setInteraction={setLastInteraction} />,
    afterChange: handleAfterChange,
    appendDots: (dots) => (
      <ul className="slick-dots">
        {dots.map((dot, index) => (
          <li key={index} onClick={() => handleDotsClick(index)}>
            {dot}
          </li>
        ))}
      </ul>
    ),
  };

  const visibleItems = showMore
    ? props?.fields?.SliderCards || []
    : props?.fields?.SliderCards?.slice(0, 3) || [];

  return (
    <div className="image-panel-carousel commonContainer " data-aos="fade-up">
      {/* <div className="header-section">
        <h2 className="on-the-way-header commmon-header">On the Way</h2>
      </div> */}
      <div className="header-section-wrapper">
        <h2>
          <span>2</span>On Ride Companion
        </h2>
      </div>
      <div className="on-the-ways">
        <Slider {...settings}>
          {props?.fields?.SliderCards?.map((item, index) => (
            <div key={index} className="carousel-content">
              <div className="card-content">
                <div className="card-centre-content">
                  <div className="card-image-wrapper">
                    {
                      <>
                        {/* <span className="serial-number">
                          {String(index + 1).padStart(2, '')}
                          <span className="underline"></span>
                        </span> */}
                        <img
                          src={item?.fields?.CardMedia?.value?.src}
                          alt={item?.fields?.CardTitle?.value}
                          className="card-image"
                          loading="lazy"
                        />
                      </>
                    }
                  </div>
                  <div className="card-heading">
                    <h2>{item?.fields?.CardTitle?.value}</h2>
                  </div>
                </div>
                <div className="card-title">
                  {/* <p className="card-snippet">{item?.fields?.CardHeading?.value}</p> */}
                  <p className="card-snippet">{item?.fields?.CardSnippet?.value}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="mobile-accordion" ref={accordionRef}>
        {visibleItems.map((item, index) => (
          <div
            key={index}
            className={`accordion-item ${expandedItem === index ? 'expanded' : ''}`}
            id={`accordion-item-${index}`}
          >
            <div
              className="accordion-header"
              onClick={() => handleAccordionClick(index, item?.fields?.CardTitle?.value)}
            >
              <span className="serial-number">{String(index + 1).padStart(2, '')}</span>
              <span className="header-text">
                <span className="header-bar">|</span>{' '}
                <span className="main-header-text">{item?.fields?.CardTitle?.value}</span>
              </span>
            </div>
            {expandedItem === index && (
              <div className="accordion-content">
                <div className="card-content">
                  <img
                    src={
                      item?.fields?.CardMedia?.value?.src ||
                      item?.fields?.CardMediaMobile?.value?.src
                    }
                    alt={item?.fields?.CardTitle?.value}
                    className="card-image"
                    loading="lazy"
                  />
                  <div className="card-heading">
                    <span className="main-header-text roboto-bold">
                      {item?.fields?.CardTitle?.value}
                    </span>
                  </div>
                  <p className="card-snippet roboto-regular">{item?.fields?.CardHeading?.value}</p>
                  <p className="card-snippet roboto-regular">{item?.fields?.CardSnippet?.value}</p>
                </div>
              </div>
            )}
          </div>
        ))}
        {props?.fields?.SliderCards?.length > 5 && (
          <div className="show-more-less-btns">
            {!showMore ? (
              <button className="show-more show-btns" onClick={handleShowMore}>
                <span>Show More</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  className="up-arrow"
                >
                  <path
                    d="M3.5 5.5L8.5 10.5L13.5 5.5"
                    stroke="#333333"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            ) : (
              <button className="show-less show-btns" onClick={handleShowLess}>
                <span>Show Less</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  className="down-arrow"
                >
                  <path
                    d="M3.5 5.5L8.5 10.5L13.5 5.5"
                    stroke="#333333"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(OnTheWaySlider);
